const Color = {
  main: "rgb(0, 153, 99)",
  digipass: "rgba(57, 54, 239, 1)",
  wework: "rgba(0, 0, 0, 1)",
};

export default Color;
